import React from 'react';

import Section from 'react-scale/components/elements/section';
import FeatureTitle from 'react-scale/components/pages/open-datasets/FeatureTitle';

const Overview = ({ children, icon, overtitle, title, text, listItems, caseColor }) => (
  <Section id="overview">
    <FeatureTitle
      iconSVG={icon}
      overtitle={overtitle}
      title={title}
      subtitle={text}
      lists={listItems}
      caseColor={caseColor}
    >
      {children}
    </FeatureTitle>
  </Section>
);

Overview.defaultProps = {
  overtitle: {
    text: 'Overview'
  },
  children: null
};

export default Overview;
